<template>
  <div>
    <div v-if="!loggedIn" class="text-center">
      <div class="row">
        <div class="col-12">
          <div class="card">
            <div class="card-body">
              <h5 class="card-title">Please Log in</h5>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div v-if="loggedIn">
      <BaseErrors :errors="errors"></BaseErrors>

      <div class="row" v-if="loading" >
        <div class="col-12">
          <div class="card">
            <div class="card-body">
              <BaseLoader :loading="loading"/>
            </div>
          </div>
        </div>
      </div>

      <div v-if="recipe" class="edit-recipe wrapper">

        <div class="row beer-info"><!-- Beer information -->
          <div class="col-12">
            <div class="card">
              <div class="card-body">
                <h5 class="card-title">Base info
                  <small class="actions">
                    <a :href="'/app/recipes/' + recipeId" class="btn btn-secondary btn-sm">View</a>
                    <a href="#" class="btn btn-secondary btn-sm" v-if="recipe.published" @click.prevent="unpublishRecipe">UnPublish</a>
                    <a href="#" class="btn btn-secondary btn-sm" v-if="!recipe.published" @click.prevent="publishRecipe">Publish</a>
                    <a href="#" class="btn btn-secondary btn-sm brew-trigger" @click.prevent="createBrewSession">Brew</a>
                    <a href="#" class="btn btn-secondary btn-sm" @click.prevent="deleteRecipe">Delete</a>
                  </small>
                </h5>
                <form action="" @submit.prevent="">
                  <div class="form-row">
                    <div class="form-group col-sm-12 col-lg-6">
                      <label for="recipe-beer-name">Name</label>
                      <input type="text"
                             v-model="recipeName"
                             @blur="updateRecipe"
                             v-bind:class="{ 'is-invalid': errorFields['Recipe_name'] }"
                             class="form-control"
                             id="recipe-beer-name"
                             placeholder="Recipe Name"
                             required>
                      <div class="invalid-feedback">{{errorFields['Recipe_name']}}</div>
                    </div>
                    <div class="form-group col-6 col-sm-12 col-lg-6">
                      <label for="recipe-beer-date">Date</label>
                      <input type="date"
                             v-model="recipeDate"
                             @blur="updateRecipe"
                             v-bind:class="{ 'is-invalid': errorFields['Recipe_date'] }"
                             class="form-control"
                             id="recipe-beer-date"
                             required>
                      <div class="invalid-feedback">{{errorFields['Recipe_name']}}</div>
                    </div>

                    <div class="form-group col-6 col-sm-6 col-lg-4">
                      <label for="recipe-type">Recipe type</label>
                      <select if="recipeTypes"
                              id="recipe-type"
                              @blur="updateRecipe"
                              class="form-control"
                              v-model="recipeTypeName">
                        <option  :selected="recipeTypeName === item.name" v-for="item in recipeTypes" v-bind:value="item.name">{{item.name}}</option>
                      </select>
                    </div>

                    <div class="form-group col-6 col-sm-3 col-lg-4">
                      <label for="recipe-eff">BH Efficiency</label>
                      <div class="input-unit">%</div>
                      <input type="number"
                             v-model.number="recipeEfficiency"
                             @blur="updateRecipe"
                             min="0"
                             max="100"
                             step="0.01"
                             id="recipe-eff"
                             v-bind:class="{ 'is-invalid': errorFields['Recipe_efficiency'] }"
                             class="form-control"
                             placeholder="BH Efficiency">
                      <div class="invalid-feedback">{{errorFields['Recipe_efficiency']}}</div>
                    </div>

                    <div class="form-group col-6 col-sm-3 col-lg-4">
                      <label for="recipe-volume">Volume</label>
                      <div class="input-unit">{{batchVolumeUnit()}}</div>
                      <input type="number"
                             v-model.number="recipeVolume"
                             min="0"
                             @blur="updateRecipe"
                             id="recipe-volume"
                             v-bind:class="{ 'is-invalid': errorFields['Recipe_volume'] }"
                             class="form-control"
                             placeholder="Batch size">
                      <div class="invalid-feedback">{{errorFields['Recipe_volume']}}</div>
                    </div>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div><!--/ Beer information -->

      <div class="row" v-if="recipe">

        <div class="col-sm-3"><!-- Beer Style -->
          <div class="card">
            <div class="card-body">
              <beer-style-guide
                :recipeUrl="recipeUrl"
                :recipe="recipe"
              ></beer-style-guide>
            </div>
          </div>
        </div><!--/ Beer Style -->

        <div class="col-sm-6"><!-- Ingredients -->
          <div class="card">
            <div class="card-body">
              <h5 class="card-title">Ingredients</h5>
              <RecipeValues :recipe="recipe" type="horizontal"></RecipeValues>
              <IngredientsList
                :recipeUrl="recipeUrl"
                :recipe="recipe">
              </IngredientsList>

            </div>
          </div>
        </div><!--/ Ingredients -->

        <div class="col-sm-3" v-if="recipe && recipe.ingredientSchedules && recipe.ingredientSchedules.length > 1"><!-- Malt Pie Chart -->
          <div class="card">
            <div class="card-body">
              <h5 class="card-title">Malt proportions</h5>
              <p class="card-text" v-if="!recipe.ingredientSchedules.length">
                No fermentables added
              </p>
              <pie-chart
                v-if="recipe.ingredientSchedules"
                :ingredientSchedules="recipe.ingredientSchedules"
              ></pie-chart>
            </div>
          </div>
        </div><!--/ Malt Pie Chart  -->

      </div>
      <div class="row" v-if="recipe">
        <div class="col-sm-3 recipe-comment"><!-- Recipe comment -->
          <div class="card">
            <div class="card-body">
              <h5 class="card-title">Other info</h5>
              <label for="recipe-comment">Recipe comment</label>
                <textarea class="form-control"
                          id="recipe-comment"
                          @blur="updateRecipe"
                          v-model="recipeComment"
                          v-bind:class="{ 'is-invalid': errorFields['Recipe_comment'] }"
                          placeholder="Any other info..." required></textarea>
                <div class="invalid-feedback">{{errorFields['Recipe_comment']}}</div>
            </div>
          </div>
        </div><!--/ Recipe comment -->
      </div>
    </div>

  </div>

</template>

<script>
    import PieChart from "../components/charts/PieChart";
    import BeerStyleGuide from "../components/BeerStyleGuide";
    import IngredientsList from "../components/IngredientsList";
    import FermGraph from "../components/FermGraph";
    import RecipeValues from "../components/RecipeValues";

    import { EventBus } from '../lib/event-bus.js';
    import { HTTP } from '../lib/http';

    export default {
        name: "edit-recipe",
        components: {
            PieChart,
            FermGraph,
            BeerStyleGuide,
            IngredientsList,
            RecipeValues
        },
        data() {
            return {
                errors: null,
                errorFields: {},
                loading: true,
                volumeUnit: null,
                recipeUrl: null,
                recipe: null,
                recipeName: null,
                recipeId: null,
                recipeVolume: null,
                recipeEfficiency: null,
                recipeComment: null,
                recipeTypeName: null,
                recipeTypes: null,
                recipeDate: null,
                loggedIn: false,
            };
        },
        methods: {
            fetchRecipe() {
                this.loading = true;
                HTTP.get(`recipes/${this.recipeId}?cache=bypass`)
                    .then(response => {
                        let recipe = response.data.data;
                        this.recipeName = recipe.name;
                        this.recipeEfficiency = recipe.efficiency * 100;
                        this.recipeTypeName = recipe.recipeType;
                        this.recipeComment = recipe.comment;
                        this.recipeUrl = response.data.links.self;
                        this.recipeDate = recipe.date;
                        this.recipe = recipe;
                        this.recipeVolume = this.batchVolume().val;
                    })
                    .catch(err => {
                        if (err.response.status === 404) {
                            localStorage.removeItem('recipeInProgress');
                        } else {
                            this.errors = [err.response.data.errors];
                        }
                    })
                    .then( () => this.loading = false);
            },
            publishRecipe() {
                if (confirm('Are you sure?')) {
                    HTTP.patch(this.recipeUrl + '/publish')
                        .then((response) => this.fetchRecipe())
                        .catch(err => {
                            this.errors = [err.response.data.errors];
                        })
                }
            },
            unpublishRecipe() {
                if (confirm('Are you sure?')) {
                    HTTP.patch(this.recipeUrl + '/unpublish')
                        .then((response) => this.fetchRecipe())
                        .catch(err => {
                            this.errors = [err.response.data.errors];
                        })
                }
            },
            deleteRecipe() {
                if (confirm('Are you sure?')) {
                    HTTP.delete(this.recipeUrl)
                        .then(response => {
                            if (this.recipeId === parseInt(localStorage.recipeInProgress)) {
                                delete localStorage.recipeInProgress;
                            }
                            vm.$forceUpdate();
                            this.$router.push('/app/recipes');
                        }).catch(err => {
                        this.errors = [err.response.data.errors];
                    })
                }
            },
            updateRecipe() {
                this.errorFields = {};
                this.errors = [];
                let data = {
                    name: this.recipeName ? this.recipeName : '',
                    created_at: this.recipeDate,
                    recipeVolume: this.recipeVolume ? `${this.recipeVolume} ${this.volumeUnit}` : '',
                    efficiency: this.recipeEfficiency ? this.recipeEfficiency / 100 : '',
                    recipeTypeName: this.recipeTypeName ? this.recipeTypeName : '',
                    comment: this.recipeComment ? this.recipeComment : ''
                };

                HTTP.patch(this.recipeUrl, {
                    data: data
                }).then(response => {
                    let recipe = response.data.data;
                    this.recipeName = recipe.name;
                    this.recipeId = recipe.id;
                    this.recipeComment = recipe.comment;
                    this.recipeEfficiency = recipe.efficiency * 100;
                    this.recipeTypeName = recipe.recipeType;
                    this.recipeUrl = response.data.links.self;
                    this.recipeDate = recipe.date;
                    this.recipe = recipe;
                    this.recipeVolume = this.batchVolume().val;
                })
                    .catch(err => {
                        this.errors = [err.response.data.errors];
                        _(this.errors[0]).each((errorItem) => {
                            this.errorFields[errorItem.field.replace('.', '_')] = errorItem.detail;
                        })
                    })
            },
            createBrewSession() {
                HTTP.post("brew-sessions", { data: {
                        recipeId: this.recipe.id
                    }
                })
                    .then(response => {
                        this.fetchRecipe();
                    })
                    .catch(err => {
                        this.errors = [err.response.data.message];
                    })
                    .then(() => {
                        this.loading = false;
                    });
            },
            fetchRecipeTypes() {
                HTTP.get(`recipe-types${this.getQueryParams()}`)
                    .then(response => {
                        this.recipeTypes = response.data.data;
                    })
                    .catch(err => {
                        this.errors = [err.response.data.errors];
                    });
            },

            batchVolume() {
                if (this.recipe.volume) {
                    return this.recipe.volume.find(
                        (vol) => {
                            return vol.unit === this.volumeUnit
                        });
                } else {
                    return { }
                }
            }
        },
        beforeMount() {
            this.loggedIn = !!localStorage.username;
            this.volumeUnit = localStorage.volumeUnit;

            EventBus.$on('volumeUnitChanged', val => {
                this.volumeUnit = val;
                this.recipeVolume = this.batchVolume().val;
            });

            EventBus.$on('logged-in', val => { this.loggedIn = val; });
            EventBus.$on('reloadRecipe', this.fetchRecipe);
        },
        mounted() {
            this.recipeId = this.$route.params.id;
            this.fetchRecipeTypes();

            if (this.loggedIn) {
                this.fetchRecipe();
            }
        }
    };
</script>

<style scoped lang="scss">
  @import "./../assets/scss/_variablesx.scss";
  $outer-padding: 20px;

  small.actions {
    float: right;

    a {
      font-size: .7em;
      margin-left: .5em;
    }
  }

  @media (max-width: 576px) {
    .brew-trigger { display: none;}
  }

  .beer-info {
    .card-body > .row {
      padding-bottom: 0;
    }
  }
</style>
